import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-features',
  templateUrl: './home-features.component.html',
  styleUrls: ['./home-features.component.scss'],
})
export class HomeFeaturesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
